module.exports = __webpack_public_path__ + "img/shareholderCard1.7908dd62.png";